module.exports = __webpack_public_path__ + "img/theme_dark.f6d512ec.svg";